module.exports = "<div class=\"container-fluid\" style=\"padding-top: 10px;\">\n  <iframe id=\"typeform-full\" width=\"100%\" height=\"800px;\" frameborder=\"0\"\n          src=\"https://jamenedo.typeform.com/to/Tsyldw\"></iframe>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /media/julen/a87ddcee-c364-426b-b833-77926fe0cdef/julen/Ironchip/Proyectos/dative/dative-FMOT/FMOT/src/app/controlCliente/controlCliente.component.html
// module id = ../../../../../src/app/controlCliente/controlCliente.component.html
// module chunks = main